import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import { MEDIA } from "../lib/media";
import ProductCard from "../components/ProductCard";
import { Reveal } from "../components/Reveal";

export default function Rituals() {
  const [rituals, setRituals] = useState([]);
  const { hash } = useLocation();
  useEffect(() => { api.get("/rituals").then(r => setRituals(r.data)); }, []);
  useEffect(() => { if (hash && rituals.length) { const el = document.getElementById(hash.slice(1)); el?.scrollIntoView({ behavior: "smooth" }); } }, [hash, rituals]);

  return (
    <div>
      <section className="relative h-[45vh] min-h-[320px] flex items-end overflow-hidden">
        <img src={MEDIA.ritual} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-forest/40" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10 pb-12 text-ivory"><span className="eyebrow text-ivory/80">Rituals</span><h1 className="serif text-5xl lg:text-6xl mt-2">Shop by Ritual</h1><p className="text-ivory/80 mt-3 max-w-lg">Considered routines for every moment of your day.</p></div>
      </section>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 space-y-24">
        {rituals.map((r) => (
          <section key={r.slug} id={r.slug} className="scroll-mt-28">
            <Reveal className="mb-8"><h2 className="serif text-4xl lg:text-5xl">{r.title}</h2><p className="text-forest/60 mt-2">{r.subtitle}</p></Reveal>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-12">
              {(r.product_details || []).map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
